export default __webpack_public_path__ + "static/FEDER-logo-753ea91158c23894e2fac68cffd9d57d.png";